import { runningClientSide } from '@benzinga/utils';
import { Referrer } from '../entities';

const OVERRIDDEN_REF_KEY = 'overriddenReferrer';

export const getDocumentReferrer = (): Referrer => {
  if (!runningClientSide()) {
    return '';
  }

  return window?.[OVERRIDDEN_REF_KEY] || document?.referrer;
};

export const setNewDocumentReferrer = (referrer: Referrer): void => {
  if (!runningClientSide()) {
    return;
  }

  if (typeof window !== 'undefined') {
    window[OVERRIDDEN_REF_KEY] = referrer;
  }
};
